/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps } from '@mui/material';

export const accountPersonalSX: SxProps = {
	p: 2,
};

export const paperHistoryOrdersSX: SxProps = {
	p: 0,
	backgroundColor: 'transparent',
};
